/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Source_TemplateInputs */

const cs_draft_source_template = /** @type {(inputs: Draft_Source_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výchozí šablony`)
};

const en_draft_source_template = /** @type {(inputs: Draft_Source_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template default`)
};

/**
* | output |
* | --- |
* | "Template default" |
*
* @param {Draft_Source_TemplateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_source_template = /** @type {((inputs?: Draft_Source_TemplateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Source_TemplateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_source_template(inputs)
	return cs_draft_source_template(inputs)
});